import {
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Input,
  Label,
  Modal,
  Segment,
  Select,
  Tab,
  Table,
  TextArea,
} from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../../../app/stores/store';
import { circuitCreationPOST, circuitType } from './../../../../app/api/types';
import agent from '../../../../app/api/agent';
import { toast } from 'react-toastify';
import { format } from 'date-fns';

export default observer(function Circuit() {
  const {
    viewStore: { getCircuitDetails, circuitDetails, addHistory },
    DeliveryStore: { circuitCreation },
    activityStore: { selectedActivity: activity },
  } = useStore();

  const [locArr, setLocArr] = useState<{
    current: circuitType;
    next: circuitType[];
    prev: circuitType[];
  }>({
    current: {
      theater: '',
      address: '',
      deliveryDate: '',
      returnDate: '',
      index: 0,
      status: '',
    },
    next: [],
    prev: [],
  });
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [addCircuitPayload, setAddCircuitPayload] =
    useState<circuitCreationPOST>({
      theater: '',
      address: '',
      deliveryDate: '',
      returnDate: '',
    });
  const [editDateClicked, setEditDateClicked] = useState(false);
  const [theatreList, setTheatreList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [msg, setMsg] = useState<string>('');
  const [returnDate, setReturnDate] = useState<{
    index: number;
    returnDate: string;
  }>({
    index: 0,
    returnDate: '',
  });

  const getMinReturnDate = () => {
    const lastCircuit = circuitDetails[circuitDetails.length - 1];
    const dateString = lastCircuit.returnDate;

    // Parse the date string (assuming the format is DD-MM-YYYY)
    const parts = dateString.split('-');
    const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;

    // Create a Date object
    const returnDate = new Date(formattedDate);

    // Add one day
    returnDate.setDate(returnDate.getDate() + 1);

    // Convert the new date to ISO format and return the date part
    return returnDate.toISOString().split('T')[0];
};
  useEffect(() => {
    if (activity?.id) {
      getCircuitDetails({
        itemId: activity?.asset_Id
      })
    }
    // eslint-disable-next-line
  }, [activity]);

  useEffect(() => {
    if (circuitDetails.length > 0) {
      const tempLoc: {
        current: circuitType;
        next: circuitType[];
        prev: circuitType[];
      } = {
        current: {
          theater: '',
          address: '',
          deliveryDate: '',
          returnDate: '',
          index: 0,
          status: '',
        },
        next: [],
        prev: [],
      };
      circuitDetails?.forEach((c: circuitType) => {
        if (c.status?.includes('Next')) {
          tempLoc.next.push(c);
        } else if (c.status?.includes('Previous')) {
          tempLoc.prev.push(c);
        } else if (c.status?.includes('Current')) {
          tempLoc.current = c;
        }
      });
      setLocArr(tempLoc);
    }
  }, [circuitDetails]);

  useEffect(() => {
    (async () => {
      const response = await agent.WorkLevels.getMasterColumn({
        masterName: 'Theatre',
        componentName: 'Theatre Name',
        filterColumn: '',
        filterValue: '',
      });
      const tempOptions = response.data?.map((tName) => {
        return {
          key: tName,
          value: tName,
          text: tName,
        };
      });
      setTheatreList(tempOptions);
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    (async () => {
      if (addCircuitPayload.theater !== '') {
        const response = await agent.WorkLevels.getMasterColumn({
          masterName: 'Theatre',
          componentName: 'Address',
          filterColumn: 'Theatre Name',
          filterValue: addCircuitPayload.theater,
        });
        setAddCircuitPayload({
          ...addCircuitPayload,
          address: response.data[0],
        });
      } else {
        setAddCircuitPayload({
          ...addCircuitPayload,
          address: '',
        });
      }
    })();
    // eslint-disable-next-line
  }, [addCircuitPayload.theater]);

  const changeDateTime = (data: string) => {
    return data
  };

  const updatePayload = (e: any, data: any) => {
    if (e.target.name === 'deliveryDate') {
      if (
        addCircuitPayload.returnDate !== '' &&
        addCircuitPayload.returnDate < e.target.value
      ) {
        setMsg('Return date must be greater than delivery Date');
      } else {
        const newArr = {
          ...addCircuitPayload,
          [data.name]: data.value,
        };
        setAddCircuitPayload(newArr);
        setMsg('');
      }
    } else if (e.target.name === 'returnDate') {
      if (addCircuitPayload.deliveryDate <= e.target.value) {
        const newArr = {
          ...addCircuitPayload,
          [data.name]: data.value,
        };
        setAddCircuitPayload(newArr);
        setMsg('');
      } else {
        setMsg('Return date must be greater than delivery Date');
      }
    } else {
      const newArr = {
        ...addCircuitPayload,
        [data.name]: data.value,
      };
      setAddCircuitPayload(newArr);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    setAddCircuitPayload({
      theater: '',
      address: '',
      deliveryDate: '',
      returnDate: '',
    });
  };

  const handleAddCircuit = async () => {
    if (!activity?.asset_Id) {
      console.error('Physical sensor RFID is undefined');
      return; 
   }
    // Function to format date from yyyy-mm-dd to dd-mm-yyyy
  const formatDate = (dateString:any) => {
    const [year, month, day] = dateString.split('-'); 
    return `${day}-${month}-${year}`;
  };

  // Format deliveryDate and returnDate
  const formattedDeliveryDate = formatDate(addCircuitPayload.deliveryDate);
  const formattedReturnDate = formatDate(addCircuitPayload.returnDate);

    const response = await circuitCreation(
      { itemId: activity?.asset_Id },
      activity?.title || '',
      {
        ...addCircuitPayload,
        deliveryDate: formattedDeliveryDate,
        returnDate: formattedReturnDate
      },
      false
    );
    if (response) {
      setMsg('');
      setTimeout(async () => {
        await getCircuitDetails({
          itemId: activity?.asset_Id
        });
      }, 300);
      setOpenModal(false);
      setAddCircuitPayload({
        theater: '',
        address: '',
        deliveryDate: '',
        returnDate: '',
      });
    }
  };

  const handleDeleteClick = async(id:any, indx:any)=>{
      const payload = {
        itemId: id,
        index: indx
      }
      await agent.HFC.HFCSingleCircuitDelete(payload)
      getCircuitDetails({
        itemId: id
      })
  }

  const returnDateChange = (e: any, data: any) => {
    const isoDate = data.value; 
    const parsedDate = new Date(isoDate);
    const formattedDate = format(parsedDate, 'dd-MM-yyyy'); 
    setReturnDate({
      index: locArr.current.index,
      returnDate: formattedDate,
    });
    // setEditDateClicked(false)
  };

  const confirmReturnDate = async () => {
    if (!activity?.physical_sensor_RFID) {
      console.error('Physical sensor RFID is undefined');
      return; 
   }
    const payload = {
      itemId: activity?.physical_sensor_RFID ,
      ...returnDate,
    };
    const response = await agent.HFC.editReturnDateCircuit(payload);
    if (response.status === 200) {
      addHistory(
        { itemId: activity?.id },
        {
          taskId: '',
          taskName: '',
          subTaskId: '',
          subTaskName: '',
          status: `Current Location Return Date is updated to ${returnDate.returnDate}`,
          date: new Date(),
        },
        true,
        false,
      );
      toast.success('Current Location Return Date Updated');
      setReturnDate({
        index: 0,
        returnDate: '',
      });
    }
  };

  const renderLocHTML = (arrayList: circuitType[] = [], name: string) => {
    let sNo = 1;
    return (
      <>
        {arrayList.length > 0 && (
          <Segment className={'MetaDataUser'}>
            <Divider horizontal>
              <Header color="teal" as="h4">
                <Icon name="address book outline" />
                {name}
              </Header>
            </Divider>
            <Table>
              <Table.Header>
                <Table.HeaderCell>S.no</Table.HeaderCell>
                <Table.HeaderCell>Theatre</Table.HeaderCell>
                <Table.HeaderCell>Address</Table.HeaderCell>
                <Table.HeaderCell>Delivery Date</Table.HeaderCell>
                <Table.HeaderCell>Return Date</Table.HeaderCell>
                {arrayList.some(eachCircuit => eachCircuit.status === 'Next Location') && (
                  <Table.HeaderCell>Actions</Table.HeaderCell>
                )}
              </Table.Header>
              <Table.Body>
                {arrayList.map((eachCircuit: circuitType) => {
                  return (
                    <Table.Row>
                      <Table.Cell>{sNo++}</Table.Cell>
                      <Table.Cell>{eachCircuit.theater}</Table.Cell>
                      <Table.Cell>{eachCircuit.address}</Table.Cell>
                      <Table.Cell>
                        {changeDateTime(eachCircuit.deliveryDate)}
                      </Table.Cell>
                      <Table.Cell>
                        {changeDateTime(eachCircuit.returnDate)}
                      </Table.Cell>
                      {
                        eachCircuit.status === 'Next Location' && (
                          <Table.Cell>
                            <Icon name='delete' link onClick={()=>handleDeleteClick(activity?.asset_Id, eachCircuit.index)} style={{ color: 'red', marginLeft: '10px' }} />
                          </Table.Cell>
                        )
                      }
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </Segment>
        )}
      </>
    );
  };

  const sortBasedOnIndex = (arrayList: circuitType[]) => {
    return arrayList.sort((a, b) => a.index - b.index);
  };

  const getMinDate = (actualDateString: string) => {
    let currentDate: any;
    if (actualDateString !== '') {
      currentDate = new Date(actualDateString);
    } else {
      const today = new Date();
      const todayDateString =today.getDate()+'-' + (today.getMonth() + 1) + today.getFullYear();
      currentDate = new Date(todayDateString);
    }
    // Add one day to the current date
    const nextDate = new Date(currentDate);
    nextDate.setDate(currentDate.getDate() + 1);

    // Format the next date as 'YYYY-MM-DD'
    const formattedNextDate = `${String(nextDate.getDate()).padStart(2, '0')}-${String(nextDate.getMonth() + 1).padStart(2, '0')}-${nextDate.getFullYear()}`;

    return formattedNextDate;
  };

  return (
    <>
      <Tab.Pane className={'metadata-parent-tab'}>
        <Segment.Group>
          {circuitDetails.length === 0 ? (
            <>
              <Header
                style={{
                  margin: '0px',
                  padding: '20px',
                  textAlign: 'center',
                }}
              >
                No Circuit Details to display.
              </Header>

              {/* <Header
                color="teal"
                as="h4"
                style={{ margin: '0 0 16px 12px', cursor: 'pointer' }}
                onClick={() => setOpenModal(true)}
              >
                <Icon name="add circle" style={{ marginRight: '8px' }} />
                Add
              </Header> */}
            </>
          ) : (
            <>
              <Segment>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '12px',
                  }}
                >
                  <Header color="teal" as="h4">
                    <Icon name="location arrow" />
                    Current Location
                  </Header>
                  <Header
                    color="teal"
                    as="h4"
                    style={{ margin: '0', cursor: 'pointer' }}
                    onClick={() => setOpenModal(true)}
                  >
                    <Icon name="add circle" style={{ marginRight: '8px' }} />
                    Add
                  </Header>
                </div>
                <Table definition style={{ marginTop: '0' }}>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell width={7}>
                        <strong>Theatre</strong>
                      </Table.Cell>
                      <Table.Cell width={7}>
                        {locArr.current.theater}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell width={7}>
                        <strong>Address</strong>
                      </Table.Cell>
                      <Table.Cell width={7}>
                        {locArr.current.address}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell width={7}>
                        <strong>Delivery Date</strong>
                      </Table.Cell>
                      <Table.Cell width={7}>
                        {changeDateTime(locArr.current?.deliveryDate)}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell width={7}>
                        <strong>Return Date</strong>
                      </Table.Cell>
                      <Table.Cell width={7}>                        
                        { !editDateClicked ?
                            <Input type= "text" value={locArr.current?.returnDate}  style={{
                              display: 'inline',
                            }} 
                            onClick={() => setEditDateClicked(true)}/> :
                            <Input
                          required={true}
                          type="date"
                          placeholder="Date of Return"
                          name="returnDate"
                          defaultValue={locArr.current?.returnDate}
                          min={
                            locArr.current?.deliveryDate.length > 0
                              ? getMinDate(locArr.current?.deliveryDate)
                              : getMinDate('')
                          }
                          max={
                            sortBasedOnIndex(locArr.next)?.[0]?.deliveryDate.length > 0
                              ? sortBasedOnIndex(locArr.next)?.[0]?.deliveryDate
                              : null
                          }
                          onChange={returnDateChange}
                          style={{
                            display: 'inline',
                          }}
                        /> 
                        }
                          
                        <Icon
                          name="check circle"
                          size="big"
                          color="teal"
                          style={{
                            cursor:
                              returnDate.returnDate === '' ||
                              locArr.current?.returnDate ===
                                returnDate.returnDate
                                ? 'auto'
                                : 'pointer',
                          }}
                          onClick={confirmReturnDate}
                          disabled={
                            returnDate.returnDate === '' ||
                            locArr.current?.returnDate === returnDate.returnDate
                          }
                        />
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Segment>
              {renderLocHTML(sortBasedOnIndex(locArr.next), 'Next Location(s)')}
              {renderLocHTML(
                sortBasedOnIndex(locArr.prev),
                'Previous Location(s)',
              )}
            </>
          )}
        </Segment.Group>
      </Tab.Pane>
      {openModal && (
        <>
          <Modal
            onClose={() => setOpenModal(false)}
            onOpen={() => setOpenModal(true)}
            open={openModal}
          >
            <Modal.Header>Add Circuit</Modal.Header>
            <Modal.Content>
              <>
                <h3>Enter the details of item Movement</h3>
                <Form>
                  <Form.Field
                    control={Select}
                    search
                    clearable
                    label="Theatre"
                    placeholder="Theatre"
                    name="theater"
                    value={addCircuitPayload.theater}
                    options={theatreList}
                    onChange={updatePayload}
                    style={{ width: '50%' }}
                  />
                  <Form.Field
                    control={TextArea}
                    name="address"
                    label="Address"
                    placeholder="Address"
                    value={addCircuitPayload.address}
                    style={{ width: '50%' }}
                    disabled
                  />
                  <label
                    style={{
                      fontWeight: '700',
                      margin: '0 0 .28571429rem 0',
                      display: 'inline-block',
                    }}
                  >
                    Date of Delivery
                  </label>
                  <Input
                    required={true}
                    type="date"
                    placeholder="Date of Delivery"
                    name="deliveryDate"
                    // value={addCircuitPayload.deliveryDate}
                    min={getMinReturnDate()}
                    onChange={updatePayload}
                    style={{
                      display: 'block',
                      width: '50%',
                      marginBottom: '1em',
                    }}
                  />
                  <label
                    style={{
                      fontWeight: '700',
                      margin: '0 0 .28571429rem 0',
                      display: 'inline-block',
                    }}
                  >
                    Date of Return
                  </label>
                  <Input
                    required={true}
                    type="date"
                    placeholder="Date of Return"
                    name="returnDate"
                    value={addCircuitPayload.returnDate}
                    min={
                      addCircuitPayload.deliveryDate.length > 0
                        ? new Date(addCircuitPayload.deliveryDate)
                            .toISOString()
                            .split('T')[0]
                        : new Date().toISOString().split('T')[0]
                    }
                    onChange={updatePayload}
                    style={{
                      display: 'block',
                      width: '50%',
                      marginBottom: '1em',
                    }}
                  />
                </Form>
                {msg !== '' && (
                  <Label basic color="red">
                    {msg}
                  </Label>
                )}
              </>
            </Modal.Content>
            <Modal.Actions>
              <Button color="black" onClick={handleClose}>
                Close
              </Button>
              <Button
                color="blue"
                onClick={handleAddCircuit}
                disabled={
                  addCircuitPayload.theater === '' ||
                  addCircuitPayload.address === '' ||
                  addCircuitPayload.deliveryDate === '' ||
                  addCircuitPayload.returnDate === ''
                }
              >
                Add Circuit
              </Button>
            </Modal.Actions>
          </Modal>
        </>
      )}
    </>
  );
});
